import {
  dialog
} from '../base';

export function isHelloVisit() {
  let params = (new URL(document.location)).searchParams;
  let hello = params.get('hello');
  if (hello) {
    dialog.open('hello');
  }
}
